// Per-second countdown hook used by the multi shop timer + the
// BattleScreen post-battle intermission pill + the per-chip disconnect
// grace. Re-renders ~4× per second so the displayed value never
// stutters by more than 250ms.

import { useEffect, useState } from 'react'

/** Returns the seconds remaining until `endsAtMs` (epoch ms), ticked
 *  at ~250ms intervals. When `endsAtMs == null` (no active countdown)
 *  returns 0 and stops the interval. */
export function useCountdown(endsAtMs: number | null): number {
  const compute = () =>
    endsAtMs == null ? 0 : Math.max(0, Math.ceil((endsAtMs - Date.now()) / 1000))
  const [remaining, setRemaining] = useState(compute)
  useEffect(() => {
    setRemaining(compute())
    if (endsAtMs == null) return
    const handle = window.setInterval(() => setRemaining(compute()), 250)
    return () => window.clearInterval(handle)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endsAtMs])
  return remaining
}

/** mm:ss formatter that returns `0:00` for non-positive inputs. */
export function formatSeconds(s: number): string {
  if (s <= 0) return '0:00'
  const mm = Math.floor(s / 60)
  const ss = String(s % 60).padStart(2, '0')
  return `${mm}:${ss}`
}
